import { defineMessages, useIntl } from 'react-intl';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import AdvancedHotkey from './component';

export const messages = defineMessages({
  name: {
    description: 'navigationHotkeys.ShipmentsReturnsPage',
    defaultMessage: 'Shipments > Returns',
    id: 'QcOcqT',
  },
});

export const hotkey = ['g', 'r'];
export const barcodeContent = '+87HFKTL2LVTN=';

const GotoShipmentsReturnsPage = ({ children }) => {
  const intl = useIntl();
  const history = useHistory();
  const handler = useCallback(() => history.push('/shipments/returns'), [history]);
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: ['gr'],
      hotkey,
      handler,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'navigation',
      isGlobal: true,
    }),
    [intl, handler],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

GotoShipmentsReturnsPage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GotoShipmentsReturnsPage;
